module.exports = __webpack_public_path__ + "img/monitorbox01.eebfcc4c.jpg";